import { makeHooksConfig } from '@virtuslab/nfs-shared/src/config/hooks';
import type { RequiredDocuments } from '@virtuslab/nfs-shared/src/config/hooks';
import {
  useUserProjectsColorsProviderAllProjectsQuery,
  useUserTimeReportBlockedMessageSpaceOwnerQuery,
  useUserTimeReportOnCallDetailsModalQuery,
  useUserTimeReportFinancesLazyQuery,
  UserProjectsColorsProviderAllProjectsDocument,
  useUserBenefitSectionsAssignedBenefitVariantsQuery,
  useUserTimeReportEntryModalLimitsQuery,
  useUserInvoicesDrawerCreateInvoiceMutation,
  useUserInvoicesDrawerRemoveInvoiceMutation,
  useUserInvoicesDrawerUpdateInvoiceMutation,
  useInvoicesDrawerInvoicesLazyQuery,
  UserTimeReportEntryModalLimitsDocument,
  useUserTimeReportLeaveAndTrainingQuery,
  useUserDirectReportingStructureQuery,
  useUserTimeReportStatsLazyQuery,
  useTimeReportWorkTimeInsightsLazyQuery,
  useUserPreviousMonthSalaryStateQuery,
  useCopyrightsDrawerCopyrightsLazyQuery,
  useUserCopyrightsDrawerCreateWorkTransferMutation,
  useUserCopyrightsDrawerRemoveWorkTransferMutation,
  useUserCopyrightsDrawerUpdateWorkTransferMutation,
  useUserCopyrightsDrawerMarkNoWorkMutation,
  useCopyrightsTrButtonQuery,
  UserBenefitSectionsAssignedBenefitVariantsDocument,
  useUserAdditionalCostsDrawerLazyQuery,
  useUserTimeReportEntryModalUpdateAbsenceRecordMutation,
  useUserTimeReportEntryModalCreateSingularAbsenceRecordMutation,
  useUserTimeReportEntryModalCreateAbsenceRecordMutation,
} from '@virtuslab/nfs-shared/src/schema/user';

export const documents: RequiredDocuments = {
  userProjectsIds: UserProjectsColorsProviderAllProjectsDocument,
  timeReportEntryModalLimits: UserTimeReportEntryModalLimitsDocument,
  assignedBenefits: UserBenefitSectionsAssignedBenefitVariantsDocument,
};

export const hooks = makeHooksConfig({
  useCopyrightsDrawerCopyrightsLazyQuery,
  useCopyrightsDrawerCreateWorkTransferMutation: useUserCopyrightsDrawerCreateWorkTransferMutation,
  useCopyrightsDrawerRemoveWorkTransferMutation: useUserCopyrightsDrawerRemoveWorkTransferMutation,
  useCopyrightsDrawerUpdateWorkTransferMutation: useUserCopyrightsDrawerUpdateWorkTransferMutation,
  useOnCallMultipliers: useUserTimeReportOnCallDetailsModalQuery,
  useProjectColors: useUserProjectsColorsProviderAllProjectsQuery,
  useUserSpaceOwner: useUserTimeReportBlockedMessageSpaceOwnerQuery,
  useTimeReportFinances: useUserTimeReportFinancesLazyQuery,
  useBenefitSectionsAssignedBenefitVariantsQuery: useUserBenefitSectionsAssignedBenefitVariantsQuery,
  useTimeReportEntryModalLimitsQuery: useUserTimeReportEntryModalLimitsQuery,
  useInvoicesDrawerUpdateInvoiceMutation: useUserInvoicesDrawerUpdateInvoiceMutation,
  useInvoicesDrawerRemoveInvoiceMutation: useUserInvoicesDrawerRemoveInvoiceMutation,
  useInvoicesDrawerCreateInvoiceMutation: useUserInvoicesDrawerCreateInvoiceMutation,
  useTimeReportLeaveAndTrainingQuery: useUserTimeReportLeaveAndTrainingQuery,
  useInvoicesDrawerInvoicesLazyQuery,
  useTimeReportWorkTimeInsightsLazyQuery,
  useTimeReportStats: useUserTimeReportStatsLazyQuery,
  useDirectReportingStructureQuery: useUserDirectReportingStructureQuery,
  usePreviousMonthSalaryStateQuery: useUserPreviousMonthSalaryStateQuery,
  useCopyrightsDrawerMarkNoTransferMutation: useUserCopyrightsDrawerMarkNoWorkMutation,
  useCopyrightsTrButtonQuery,
  useAdditionalCostsLazyQuery: useUserAdditionalCostsDrawerLazyQuery,
  useTimeReportEntryModalUpdateAbsenceRecordMutation: useUserTimeReportEntryModalUpdateAbsenceRecordMutation,
  useTimeReportEntryModalCreateAbsenceRecordMutation:
    useUserTimeReportEntryModalCreateAbsenceRecordMutation,
  useTimeReportEntryModalCreateSingularAbsenceRecordMutation:
    useUserTimeReportEntryModalCreateSingularAbsenceRecordMutation,
});
